
import { FIELD_STATUS } from '../../../reducers/status';
import {
    getPersonalDetailsForm,

} from '../../../selectors/digiLifeLoanProtection/personalDetails';
import { DLP_PERSONAL_DETAILS_SCROLL_ID } from '../status';
import { transitionScrolling } from '../../../actions/digiLifeLoanProtection/scrolling';
import { setDeceasedDetailsValue, transitionDeceasedDetails } from '../../../actions/sizotsaFuneralClaim/deceasedDetails';
import { getDeceasedDetailsValidations } from '../../../selectors/sizotsaFuneralClaim/deceasedDetails';

export const deceasedDetailsRules = (store, next, action) => {
    const result = next(action);

    const isValid = isDeceasedDetailsValid(store);
    store.dispatch(isValid ? transitionDeceasedDetails.formValid() : transitionDeceasedDetails.formInvalid());

    return result;
};

// Personal Information
const isDeceasedDetailsValid = (store) => {
    const state = store.getState();
    const isValid = (field) => {
        return field && field.status === FIELD_STATUS.VALID;
    };
    const deceasedDetailsValidations = getDeceasedDetailsValidations(state);
    const deceasedDetailsFormFields = [...Object.values(deceasedDetailsValidations)];

    const deceasedDetailsValid = deceasedDetailsFormFields.every(isValid);
    return deceasedDetailsValid;
};

export const performDeceasedDetailsValidation = (store) => {
    const createDispatchHandler = (fieldType, value, displayValue) => {
        store.dispatch(setDeceasedDetailsValue({ fieldType, value, displayValue }));
    };
    const state = store.getState();

    const deceasedDetailsFormFields = getDeceasedDetailsValidations(state);
    Object.keys(deceasedDetailsFormFields).map((property) => {
        const { value, displayValue } = deceasedDetailsFormFields[property];
        createDispatchHandler(property, value, displayValue);
    });
    setScrollError(store);
};

export const setScrollError = (store) => {
    const state = store.getState();
    const fieldKeyArr = DLP_PERSONAL_DETAILS_SCROLL_ID;
    const personalDetailsForm = getPersonalDetailsForm(state);
    const firstErrorField = fieldKeyArr.find(
        (fieldKey) => fieldKey in personalDetailsForm && personalDetailsForm[fieldKey].error
    );

    store.dispatch(transitionScrolling.scrollToId(firstErrorField));
};
